<template>
  <label class="radio-container"
    >{{ buttonLabel }}
    <input v-model="radioButtonValue" type="radio" :name="name" :value="label" v-on="listeners" />
    <span class="checkmark"></span>
  </label>
</template>

<script>
export default {
  name: 'TolRadioButton',
  inheritAttrs: false,
  props: {
    buttonLabel: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    value: {
      type: [String, Boolean, Number],
      default: ''
    },
    label: {
      type: String,
      default: null
    }
  },
  computed: {
    attrs() {
      return this.$attrs;
    },
    listeners() {
      const { ...listeners } = this.$listeners;
      return listeners;
    },
    radioButtonValue: {
      get() {
        return this.value;
      },
      set() {
        this.$emit('toggle', this.label);
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/app/styles/colors.scss';
@import '@/app/styles/variables.scss';

.radio-container {
  display: flex;
  align-items: center;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  height: 25px;
  user-select: none;

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 25px;
    width: 25px;
    background-color: $light-grey-2;
    border-radius: 50%;

    &:after {
      content: '';
      position: absolute;
      display: none;
    }
  }

  &:hover input ~ .checkmark {
    background-color: $light-grey-3;
  }

  input:checked ~ .checkmark {
    background-color: $toggle-switch-blue;

    &:after {
      display: block;
    }
  }

  .checkmark:after {
    top: 9px;
    left: 9px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: $white;
  }
}
</style>
